const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-custom-inline-script'] = {
        c: () => require('partner/modules/dobbies-custom-inline-script/dobbies-custom-inline-script.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-custom-inline-script',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-custom-inline-script'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-custom-inline-script|dobbies-custom-inline-script'] = {
                c: () => require('partner/modules/dobbies-custom-inline-script/dobbies-custom-inline-script.view.tsx'),
                cn: '__local__-__local__-dobbies-custom-inline-script'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };